import { SignIn } from "@clerk/clerk-react";
import { PageContainer } from "../components/layout/PageContainer";

export function LoginPage() {
  return (
    <PageContainer>
      <div className="flex justify-center py-12">
        <SignIn
          routing="hash"
          signUpUrl="/signup"
          fallbackRedirectUrl="/dashboard"
          signUpForceRedirectUrl="/onboarding"
          appearance={{
            elements: {
              rootBox: "mx-auto",
              card: "bg-card border border-border/50",
            },
          }}
        />
      </div>
    </PageContainer>
  );
}
